import React, { useMemo } from 'react'
import { ComparisonCardProps } from './modules';
import ComparisonCard from './ComparisonCard';
import { Skeleton } from 'src/shadcn/components/ui';

type Props = {
    items: ComparisonCardProps[];
}

const ComparisonDashboard2 = ({ items }: Props) => {

    return (
        <div className="flex-1">
            <div className="text-xs font-medium text-gray-700 mb-2">Comparison Dashboard</div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2">
                { items.map((item, index) => (
                    <ComparisonCard key={`comparison-${index}`} {...item} />
                ))}
            </div>
        </div>
    )
}

export default ComparisonDashboard2